function PolygonIcon() {
  return(
    <svg width="26" height="15" viewBox="0 0 26 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 0L25.9904 15H0.00961876L13 0Z" fill="#990000"/>
    </svg>
  );
}

export default PolygonIcon;
